/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `BLACK_ON_BLACK` - Black On Black
 * * `WHITE_ON_BLACK` - White On Black
 */
export type ColorSchemeEnum = typeof ColorSchemeEnum[keyof typeof ColorSchemeEnum];


export const ColorSchemeEnum = {
  BLACK_ON_BLACK: 'BLACK_ON_BLACK',
  WHITE_ON_BLACK: 'WHITE_ON_BLACK',
} as const;
